import React from "react";
import Seo from "@/components/Seo";
import GulfNewswireHero from "@/components/marketing/gulf/GulfNewswireHero";
import GulfNewswireCoverage from "@/components/marketing/gulf/GulfNewswireCoverage";
import GulfNewswireIncluded from "@/components/marketing/gulf/GulfNewswireIncluded";
import GulfNewswireMidCTA from "@/components/marketing/gulf/GulfNewswireMidCTA";
import GulfNewswireUpgrade from "@/components/marketing/gulf/GulfNewswireUpgrade";
import GulfNewswireFAQ from "@/components/marketing/gulf/GulfNewswireFAQ";
import HowItWorksLedger from "@/components/marketing/service/HowItWorksLedger";
import CTASection from "@/components/marketing/CTASection";
import Reveal from "@/components/marketing/Reveal";

const STEPS = [
  { title: "Create your free account", desc: "Sign up free, no credit card required." },
  { title: "Upload your release", desc: "Submit in English, Arabic, or both. We handle translation." },
  { title: "We distribute same day", desc: "Your release goes out across Gulf media, typically within 30 minutes of approval." },
  { title: "Get your reports", desc: "A 2 day coverage report and a 10 day final report with live published links." },
];

export default function GulfNewswire() {
  return (
    <div className="bg-canvas">
      <Seo
        title="Gulf Newswire Distribution From $475"
        description="Distribute your press release across Gulf media for $475. Covers UAE, Saudi Arabia, Qatar, Kuwait, Bahrain and Oman, with Arabic translation included and full coverage reports."
      />
      <GulfNewswireHero />
      <Reveal>
        <GulfNewswireCoverage />
      </Reveal>
      <Reveal variant="card">
        <GulfNewswireIncluded />
      </Reveal>
      <Reveal>
        <GulfNewswireMidCTA />
      </Reveal>
      <div id="how-it-works">
        <HowItWorksLedger
          steps={STEPS}
          tag="HOW IT WORKS"
          title="How Gulf newswire distribution works"
        />
      </div>
      <Reveal variant="card">
        <GulfNewswireUpgrade />
      </Reveal>
      <Reveal variant="card">
        <GulfNewswireFAQ />
      </Reveal>
      <CTASection
        eyebrow="GET STARTED"
        headline="Ready to reach Gulf media today?"
        subtitle="Fixed $475. English and Arabic. Reports included."
        primaryTo="/register"
      />
    </div>
  );
}